import { Link } from "react-router-dom";

// GRID VIEW

export default function BlogListItem3({ item, index, style }) {
  let title = item.properties.Name?.title[0]?.plain_text;
  let summary = item.properties.Summary?.rich_text?.[0]?.plain_text;
  let date = item.properties.Date.formula.string;
  let days = item.properties.Days.formula.string;
  let tags = item.properties.Tags.multi_select;
  let category = item.properties.Category.multi_select;
  let link = item.properties.Link?.rich_text?.[0]?.plain_text;
  let created = item.properties.Created_date.formula.string;
  let edited = item.properties.Edited_date.formula.string;
  let thumbnail = item.icon?.file?.url || null;

  const imageUrl = thumbnail;

  return (
    <Link
      className="a"
      to={`/blog/${item.id}`}
      state={{
        title,
        summary,
        date,
        tags,
        created,
        edited,
        category,
        days,
        link
      }}
      style={{ textDecoration: "none", ...style }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
          background: imageUrl
            ? `url('${imageUrl}') center center/${index === 0 ? 'cover' : 'contain'} no-repeat`
            : "transparent",
          position: "relative",
          overflow: "hidden",
          width: "100%",
          height: "100%"
        }}
      >
        
        {/* <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: "100%",
            background: "linear-gradient(to top, rgba(0,0,0,0.2) -10%, rgba(0,0,0,0) 40%)",
            zIndex: 1
          }}
        /> */}

        {/* <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
            color: "white",
            fontWeight: 500,
            fontSize: "var(--font-size-small)",
            wordBreak: "break-word",
            lineHeight: 1.2,
            padding: 8,
          }}
        >
          {title}
        </div> */}
        
      </div>
      
    </Link>
  );
}
